import classNames from "classnames";
import Link from "next/link";

type Props = {
  slug: string;
  onClick?: () => void;
  className?: string;
};
const WriteReviewButton = ({
  slug,
  onClick = () => false,
  className = "",
}: Props) => (
  <Link
    prefetch={false}
    href={`/strains/${slug}/reviews/write-review`}
    className={classNames(className, "button button--secondary block")}
    onClick={onClick}
  >
    write a review
  </Link>
);

export default WriteReviewButton;
